// extracted by mini-css-extract-plugin
export default {"text404":"Page404_text404__9mbM5"};